import React, { useEffect, useState } from 'react';

import { navigate } from '@reach/router';
import PropTypes, { array } from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Card, CardContent, Grid, Button, Box, Tooltip, Tabs, Tab,MenuItem, Select, } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import PageFeedback from '../../components/PageFeedback/PageFeedback';
import ShowAlert from '../../components/ShowAlert/ShowAlert';
import Feedback from '../../components/Feedback/Feedback';
import StatusService from '../../services/StatusService/StatusService';
import AuditLogService from '../../services/AuditLog/AuditLogService';



// Define component styling
const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  card: {
    width: '100%',
    maxWidth: 1040,
    height: "377px",
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  cardHeader: {
    backgroundColor: '#fff',
    // padding: "16px 0 0 0",
    padding: "0 0 0 0",
    borderBottom: '1px solid #ddd',
    position: 'relative',
    height:"68px"
  },
  // title: {
  //   fontSize: 20,
  //   fontWeight: 600,
  // },
  tabMain:{
    height:"1005"
   },

  customTab: {
    '&.Mui-selected': {
      color: '#79232e',
      borderBottom: '2px solid #79232e',
      fontWeight: 500,
    },
    height:"68px",
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: 14,
    fontWeight: 400,
    transition: 'color 0.1s ease, border-bottom 0.1s ease, font-weight 0.1s ease',
  },
  cardBody: {
    padding: theme.spacing(3),
    maxHeight: "290px",
    height: "290px",
    display: "grid",
    marginBottom: "10px",

  },

  property: {
    marginTop: 6,
    fontSize: 16,
  },
  value: {
    marginTop: 6,
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  CardLeftSection:{
    width:"23%",
    position: "absolute",
    top: "0px",
    right: "10px",
    // fontSize: "20px",
    display: "flex",
    alignItems: "center",

    height:"100%"
 
  },
  cardFooter: {
    padding: theme.spacing(2),
    borderTop: '1px solid #ddd',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    fontSize: '12px',
    textTransform: 'capitalize',
    borderRadius: '100px',
    // paddingLeft: '2rem',
    padding: '0.5rem 2rem',
    // marginTop: theme.spacing(1.875),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: '#79232e',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#a12e3d'
    },
    '&:active': {
      color: '#fff',
      backgroundColor: '#79232e'
    },
    '&:focus': {
      color: '#fff',
      backgroundColor: '#79232e'
    }
  },

  auditLogstyle: {
    paddingBottom: "1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    padding: "8px",
    margin: "0px",
  },
  AuditContent: {
    fontSize: "13px"
  },
// ------------------table

/* Tabs */
// .tabs {
//   display: flex;
//   padding: 15px 20px;
//   justify-content: space-between;
//   border-bottom: 1px solid #8b1d22;
// }
// .tabs_inner {
//   display: flex;
//   align-items: center;
// }
// .tab {
//   margin-right: 30px;
//   font-weight: 600;
//   cursor: pointer;
//   color: #777;
// }

// .tab.active {
//   color: #8b1d22;
// }

Orderinfo: {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "2rem",
  padding: "5px 0px 10px 16px",
  backgroundColor: "#f2f2f2",
  '& span': {
    fontWeight: 600,  
    marginRight: "2px"
  }
},

/* Table */
tblMain: {
  width: "100%",
  borderCollapse: "collapse",
'& tr': {
  height: 'auto',
},
  '& td': {
    verticalAlign: 'top',
    padding: '8px',
    textAlign: 'left',
    overflow: 'hidden',      
  },

  '& th': {
    textAlign: 'left',
    padding: '12px 12px 12px 6px',
  },
},

th: {
  background: "#fafafa",
 textAlign: "left",
  padding: "12px 12px 12px 7px",
  fontSize: "14px",
  borderBottom: "1px solid #ddd",
},

td: {
  padding: "12px",
  borderBottom: "1px solid #eee",
  fontSize: "14px",
},

/* Buttons */
btn: {
    padding: "6px 10px",
    fontSize: "12px",
    borderRadius: "20px",
    border: "none",
    cursor: "pointer",
    marginRight: "5px",
},

btnReport :{
  backgroundColor: "#8b1d22",
    color: "white",
},

btnInvoice: {
  backgroundColor: "white",
    color: "#8b1d22",
    border: "1px solid #8b1d22",
},
// reportBox:{
//   display: "inline-flex",
//   flexDirection: "column",
//   alignItems: "center",
//   margin: "0px 5px",
//   maxHeight: '60px',        
//   overflowY: 'auto', 
// },

reportmain: {
  display: "flex",
  width: "auto", 
},
reportContainer: {
  // gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "6px",
  width: "auto", 
},

Status:{
  
  fontWeight: "bold",
}

}));

const OrderDetailsPage = (props) => {
  // Bind styling
  const classes = useStyles();
  const token = JSON.parse(localStorage.getItem('auth'));


  // Initialize Order Details Page state variables
  const [fullPageLoad, setFullPageLoad] = useState(false);
  const [orderInformation, setOrderInformation] = useState(null);
  const [auditLogInformation, setAuditLogInformation] = useState(null);
  const [alert, setAlert] = useState({ message: '', severity: 'info', open: false });
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Initialize connection to Host JavaScript API
  const host = props.host;

  const initializeOrderInformation = async (transactionId) => {
    const statusTracker = StatusService(transactionId, token.token);
    const response = await statusTracker.getStatus();
    const currentStatus = response?.status;
    const message = response?.message;
    const AuditLogTracker = AuditLogService(transactionId, token.token);
    const AuditLogresponse = await AuditLogTracker.getAuditLog();
    if (currentStatus === 'Failed' && message) {
      showAlert("Oops! Something went wrong. See Order Trail.", 'error')
    }
    if (AuditLogresponse == null) {
      console.log("AuditLog response is null:", AuditLogresponse)
    }
    setOrderInformation(response);
    console.log("AuditLogresponse AuditLogresponse", AuditLogresponse);
    setAuditLogInformation(AuditLogresponse);
  };

  useEffect(() => {
    initializeOrderInformation(props.transactionId);

  }, []);

  
  
  useEffect(() => {

    if (orderInformation?.borrowerInfo) {
      orderInformation.borrowerInfo.sort((a, b) => {
        return Number(a.orderNumber) - Number(b.orderNumber);
      });
      
    const validOrders = orderInformation?.borrowerInfo?.filter(
      item => item.orderNumber && item.orderNumber.trim() !== ""
    );
  
    if (validOrders?.length > 0) {
      setSelectedOrder(validOrders[0]);
    }
  }
  }, [orderInformation]);
  const showAlert = (message, severity = 'info') => {
    setAlert({ message, severity, open: true });
  };


  const viewReport = async (Keyword) => {
    debugger
    setFullPageLoad(true);

    // Await host connection resolution
    const proxy = await host;

    const index = orderInformation.resources.findIndex(resource =>
      resource?.name?.toLowerCase().includes(Keyword.toLowerCase())
    );
    try {

      await proxy.openResourceInModal({
        target:
        {
          entityId: orderInformation.resources[index].id,
          entityType: 'urn:elli:skydrive',
        },

      });
    } catch (err) {
      console.log(err);
    }

    setFullPageLoad(false);
  };


  const getReportsByOrder = (orderNumber) => {
    // Filter all reports for this order
    return orderInformation?.resources?.filter(r =>
      r.name.toLowerCase().includes('report_') &&
      r.name.includes(orderNumber)
    ) || [];
  };
 

  const displayDate = (date) => date?.substring(0, 16).replace("T", " ");

  const [isRotating, setIsRotating] = useState(false);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClick = () => {
    setIsRotating(true);
    initializeOrderInformation(props.transactionId);

    setTimeout(() => {
      setIsRotating(false);
    }, 500);
  };

  return (
    <React.Fragment>
      {fullPageLoad === true && (
        <PageFeedback open={fullPageLoad} message='Loading...' />
      )}
      <ShowAlert open={alert.open} message={alert.message} severity={alert.severity} />
      <Paper className={classes.paper}>
        <Card className={classes.card}>

          {/* Card Header */}
          <div className={classes.cardHeader}>
            <Tabs
            className={classes.tabMain}
              value={value}
              onChange={handleChange}
              indicatorColor="none"
              textColor="primary"
            >
              <Tab label="Order Details" className={classes.customTab} />
              <Tab label="Order Trail" className={classes.customTab} />
            </Tabs>
            {/* <Typography className={classes.title}>
              View Order Details
            </Typography> */}
                
            <Box className={classes.CardLeftSection} >
            <Grid container justify='center'>
                          <Button
                            variant='contained'
                            className={classes.button}
                            onClick={() =>
                              navigate('/voie/order')
                            }
                          >
                            New Order
                          </Button>
                        </Grid>
              <Tooltip title="Refresh" arrow>
                <span onClick={handleClick} style={{ cursor: "pointer" }}>
                  <ReplayIcon style={{
                    transition: 'transform 1s',
                    transform: isRotating ? 'rotate(-360deg)' : 'rotate(0deg)',
                  }} />
                </span>
              </Tooltip>
            </Box>
          </div>
<Grid  className={classes.Orderinfo}><div><span>Loan# </span>{orderInformation?.loanNumber}</div><div><span>Provider </span>{orderInformation?.provider}</div></Grid>

          <React.Fragment>
            {orderInformation === null ? (
              <Feedback message='Loading order details...' />
            ) : (
              <React.Fragment>
                {/* Card Body */}
                <CardContent className={classes.cardBody} style={{ overflow: value === 1 ? "auto" : "" }}>
                  {value === 0 && (
                    <Grid container spacing={3}>
{/* ---------table */}
<table className={classes.tblMain}>
      <thead>
        <tr>
          {/* <th>Order #</th> */}
          <th>Borrower Name</th>
          <th>Primary</th>
          <th>Reports</th>
          <th>Invoice</th>
          <th>Status</th>
          <th>Created Date</th>
          <th>Completed Date</th>
        </tr>
      </thead>

      <tbody>
      {orderInformation?.borrowerInfo?.map((borrower, index) => (

          <tr key={index}>
          {/* <td>{borrower.orderNumber}</td> */}
          <td>{borrower.borrowerName}</td>
          <td>{borrower.primary ? "Yes" : "No"}</td>

          <td className={classes.reportmain}>
          <div className={classes.reportContainer}>
    {getReportsByOrder(borrower.orderNumber).map((report, index) => (
      <button
        key={index}
        className={`${classes.btn} ${classes.btnReport}`}
        onClick={() => viewReport(report.name)}
      >
        {report.reportType || "Report"}
      </button>
    ))}
  </div>

  
</td>
<td>
  {(() => {
    const invoiceFile = orderInformation?.resources?.find(r =>
      r.name.toLowerCase().includes('invoice_') &&
      r.name.includes(borrower.orderNumber)
    );
    return invoiceFile ? (
      <button
        className={`${classes.btn} ${classes.btnInvoice}`}
        onClick={() => viewReport(invoiceFile.name)}
      >
        {invoiceFile.reportType || "Invoice"}
      </button>
    ) : null;
  })()}
</td>

<td
  className={classes.Status}
  style={{
    color:
      borrower?.status?.toLowerCase() === ""
        ? "black"
        : "green"
  }}
>
  {borrower?.status?.trim() ? borrower.status : "Pending"}
</td>
          <td >{displayDate(borrower.createdDate)}</td>
          <td >{displayDate(borrower.updatedDate)}</td>
    </tr>
        ))}
       
      </tbody>
    </table>
{/* ---------table */}



                      {/* <Grid item xs={6}>
                        <Grid container justify='center'>
                          <Typography className={classes.property}>
                            Order Status
                          </Typography>
                        </Grid>
                        <Grid container justify='center'>
                          <Typography className={classes.value}>
                          {selectedOrder?.status || "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container justify='center'>
                          <Typography className={classes.property}>
                            Order Number
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="center">
                            <Select
                            value={selectedOrder?.orderNumber || ""}
                            onChange={(e) => {
                              const selected = orderInformation?.borrowerInfo?.find(
                                (b) => b.orderNumber === e.target.value
                              );
                              setSelectedOrder(selected);
                            }}
                          >
                          {orderInformation?.borrowerInfo
                            ?.filter(item => item.orderNumber && item.orderNumber.trim() !== "")
                            .map((item, index) => (
                              <MenuItem key={item.orderNumber} value={item.orderNumber}>
                                {item.orderNumber}
                              </MenuItem>
                          ))}
                          </Select>
                            </Grid>
                      </Grid>
                      </Grid> */}
                      {/* <Grid item xs={12}>
                        {/* <Grid container justifyContent="center" sx={{ display: "flex", gap: 2 }} >

                          <Button
                            variant='contained'
                            color='primary'
                            className={classes.button}
                            onClick={() => viewReport(`Report_${selectedOrder?.orderNumber}`)}
                            disabled={!orderInformation?.resources || !Array.isArray(orderInformation?.resources) || !orderInformation.resources.some(r => r.name.toLowerCase().includes(`report_${selectedOrder?.orderNumber}`))}
                          >
                            View Report
                          </Button>

                          <Button
                            variant='contained'
                            color='primary'
                            className={classes.button}
                            onClick={() => viewReport(`Invoice_${selectedOrder?.orderNumber}`)}
                            disabled={!orderInformation?.resources || !Array.isArray(orderInformation?.resources) || !orderInformation.resources.some(r => r.name.toLowerCase().includes(`invoice_${selectedOrder?.orderNumber}`))}
                          >
                            View Invoice

                          </Button>

                        </Grid> 
                        
                        <Grid container justify='center'>
                          <Button
                            variant='contained'
                            className={classes.button}
                            onClick={() =>
                              navigate('/voie/order')
                            }
                          >
                            New Order
                          </Button>
                        </Grid>
                      </Grid> */}
                    </Grid>
                  )}
                  {value === 1 && (
                    <Grid container spacing={3}>

                      {auditLogInformation && auditLogInformation.length > 0 ? (auditLogInformation.map((item, index) => (

                        <Grid xs={12} key={index} className={classes.auditLogstyle}
                          style={{
                            borderBottom: index !== auditLogInformation.length - 1 ? "1px solid rgb(121 35 46)" : "none",
                            backgroundColor: index % 2 === 0 ? "#f1eeee" : "transparent",
                          }}
                        >
                          <Typography variant="body1" className={classes.AuditContent}><strong>Date:</strong> {item.createdAt}</Typography>
                          {/* <Typography variant="body1" className={classes.AuditContent}><strong>Description:</strong> {item.text}</Typography> */}
                          {item.message?.trim() && (<Typography variant="body1" className={classes.AuditContent}><strong>Message:</strong><pre style={{margin:"0"}} >{item.message}</pre></Typography>) }  
                        </Grid>

                      ))

                      ) : (
                        <Typography variant="body2" color="textSecondary">No audit log data found.</Typography>
                      )
                      }


                    </Grid>
                  )}
                </CardContent>
              </React.Fragment>
            )}
          </React.Fragment>



        </Card>
      </Paper>
    </React.Fragment>
  );
};

OrderDetailsPage.propTypes = {
  host: PropTypes.object.isRequired,
  transactionId: PropTypes.string.isRequired,
};

export default OrderDetailsPage;